import React from 'react';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import AssignmentFilter from './AssignmentFilter';

const tAssignment = (key, options?) => translate('assignment', key, options);

const AssignmentHeader = ({ name }) => {
  const classes = useStyles();

  return (
    <Box className={classes.headerContainer}>
      <Box>
        <Typography variant="h1" className={classes.headerTitle}>
          {tAssignment('assignmentsTitle', {
            name,
          })}
        </Typography>
        <Typography variant="subtitle1" className={classes.headerSubtitle}>
          {tAssignment('assignmentsSubtitle')}
        </Typography>
      </Box>
      <Box>
        <AssignmentFilter />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  headerContainer: {
    margin: 10,
    marginBottom: 25,
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerTitle: {
    fontSize: remCalc(32),
    lineHeight: remCalc(48),
  },
  headerSubtitle: {
    fontSize: remCalc(16),
    lineHeight: remCalc(28),
  },
}));

export default AssignmentHeader;
